<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom mb-5">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12" style="text-align: right;">
                <button class="btn btn-success" type="button" style="margin: 5px;" (click)="addNew()">Add New
                    Request</button>
            </div>
        </div>
        <div class="row">
            <div class="card col-lg-12 col-md-12 col-12">
                <div class="row">
                    <div class="col-md-11">
                        <div class="py-3">
                            <input type="text" id="searchtext" class="form-control bg-white border-0 small"
                                placeholder="Search for..." [(ngModel)]="searchtext" aria-label="Search"
                                aria-describedby="basic-addon2" />
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="py-3">
                        <button class="btn btn-success" (click)="getSchoolFeesIncreaseList(1);"
                            style="margin: 5px;">Search</button>
                            </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                        <thead>
                            <tr>
                                <th class="pointer" scope="col" (click)="sortBy('RequestDate')">Request date </th>
                                <th class="pointer" scope="col" (click)="sortBy('AcademicYear')">Academic year </th>
                                <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                <th class="pointer" scope="col" (click)="sortBy('Course')">Course</th>
                                <th class="pointer" scope="col" (click)="sortBy('InstituteType')">Institute Type</th>
                                <th class="pointer" scope="col" (click)="sortBy('CourseYear')">Course year</th>
                                <th class="pointer" scope="col" (click)="sortBy('TotalAmount')">Total amount</th>
                                <th class="pointer" scope="col" (click)="sortBy('Remark')">Remark</th>
                                <th class="pointer" scope="col" (click)="sortBy('AdminRemark')">Admin Remark</th>
                                <th class="pointer" scope="col" (click)="sortBy('Status')">Status</th>
                                <th class="pointer" scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="SchoolFeesIncreaseList != undefined && SchoolFeesIncreaseList.length > 0">
                            <tr
                                *ngFor="let r of SchoolFeesIncreaseList  | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalFees};let i = index">
                                <td>
                                    <p>{{r.RequestDate}}</p>
                                </td>
                                <td>
                                    <p>{{r.AcademicYear}}</p>
                                </td>
                                <td>
                                    <p>{{r.Medium}}</p>
                                </td>
                                <td>
                                    <p>{{r.Course}}</p>
                                </td>
                                <td>
                                    <p>{{r.InstituteType}}</p>
                                </td>
                                <td>
                                    <p>{{r.CourseYear}}</p>
                                </td>
                                <td>
                                    <p>{{r.TotalAmount}}</p>
                                </td>
                                <td>
                                    <p>{{r.Remark}}</p>
                                </td>
                                <td>
                                    <p>{{r.AdminRemark}}</p>
                                </td>
                                <td>
                                    <p *ngIf="r.Status == 1 " style="color: green;font-weight: bold;">
                                        Approved
                                    </p>
                                    <p *ngIf="r.Status == 2" style="color: red;font-weight: bold;">
                                        Rejected
                                    </p>
                                    <p *ngIf="r.Status == 0" style="color: black;font-weight: bold;">
                                        Pending
                                    </p>
                                </td>

                                <td>
                                    <span *ngIf="r.Status == 2">
                                        <button type="button" class="btn btn-success rmb_10"
                                            (click)="editRequest(r.HashCode)">Edit</button>
                                        &nbsp;
                                    </span>
                                    <span *ngIf="r.Status != 1">
                                        <button type="button" class="btn btn-danger"
                                            (click)="deleteRequest(r.HashCode)">Delete</button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="SchoolFeesIncreaseList == undefined || SchoolFeesIncreaseList.length == 0">
                            <tr>
                                <td colspan="11" style="text-align: center;">
                                    No record found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer pb-0 pt-3" align="right" *ngIf="SchoolFeesIncreaseList != undefined && SchoolFeesIncreaseList.length > 0">
                    <pagination-controls (pageChange)="getSchoolFeesIncreaseList($event)" responsive="true"
                    maxSize="{{totalPages}}"></pagination-controls>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>